
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[idOrSlug]",
      function () {
        return require("private-next-pages/event/[idOrSlug]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[idOrSlug]"])
      });
    }
  